<template>
  <v-row justify="center">
    <v-dialog v-model="newFoodDialog" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark v-bind="attrs" v-on="on">
          New Food
        </v-btn>
      </template>
      <CreateFoodCard
        v-on:close="newFoodDialog = false"
        v-on:save="saveNewFood"
      ></CreateFoodCard>
    </v-dialog>
  </v-row>
</template>

<script>
import CreateFoodCard from '@/components/CreateFoodCard';
export default {
  name: 'CreateFoodDialog',
  components: {
    CreateFoodCard,
  },
  data() {
    return {
      newFoodDialog: false,
    };
  },
  methods: {
    async saveNewFood(value) {
      await this.$store.dispatch('addFood', value);
      this.newFoodDialog = false;
    },
  },
};
</script>
